/**
 * Returns a string array with possible filtering options.
 * @type {string[]}
 */
export const visibilityFilteringOptions = ["Images", "Pdf", "Videos"];

/**
 * Refresh timeout for checking backend status.
 * In milliseconds.
 * @type {number}
 */
export const STATUS_REFRESH_TIMEOUT = 1000 * 5;
/**
 * Refresh timeout for checking if the config is created.
 * In milliseconds.
 * @type {number}
 */
export const NEW_DRIVE_CONFIG_REFRESH_TIMEOUT = 1000;
export const MODAL_ROOT_ELEMENT = "modal-root";

export const USER_NAME_KEY = "userName";
export const AUTH_KEY = "authKey";
export const PASSWORD_KEY = "password";
export const IP_ADDRESS_KEY = "ipAddress";
export const LOGIN_TOKEN = "login_token";

export const FILES_VIEW_HEIGHT = "75vh";